/* eslint-disable warp-drive/no-legacy-request-patterns */
import ReportTemplateType from '@linc-technologies/linced-common/enums/reports/report-template-type';
import Scopes from '@linc-technologies/linced-common/enums/scopes';

// Soft-deleted templates (LINC-ED only). Fetched separately and deliberately
// NOT pushed into the store, so they stay out of the findAll collection and
// can't leak into the active/inactive lists. Returns [] for non-LINC-ED users
// and on error so the page still renders. The endpoint returns every version,
// so keep one row per chain (latest, no `next`), most-recently-deleted first.
export async function loadDeletedReportTemplates({
  fetch,
  permissions,
  session,
  store,
}) {
  if (!permissions.meet(Scopes.LINCED_MANAGER)) return [];
  try {
    let adapter = store.adapterFor('reports/report-template');
    let host = adapter.host || '';
    let url = `${host}/${adapter.namespace}/report-templates/deleted?schoolId=${session.activeSchool}`;
    let payload = await fetch.request(url);
    let deleted = (payload.reportTemplates || [])
      .filter(
        (t) => t.type === ReportTemplateType.REPORT && !t.next && !t.isGlobal,
      )
      .sort((a, b) => (b.deleteTime || 0) - (a.deleteTime || 0));

    // Resolve the deleting user's name for display. deletedBy is a person id
    // (the JWT subject). Load each once; fall back to no name if it can't be
    // resolved (empty deletedBy, older deletes, or an inaccessible person).
    let deleterIds = [
      ...new Set(deleted.map((t) => t.deletedBy).filter(Boolean)),
    ];
    let persons = await Promise.all(
      deleterIds.map((id) => store.findRecord('person', id).catch(() => null)),
    );
    let nameById = {};
    persons.filter(Boolean).forEach((p) => {
      nameById[p.get('id')] = p.get('fullName');
    });
    deleted.forEach((t) => {
      t.deletedByName = t.deletedBy ? nameById[t.deletedBy] || null : null;
    });

    return deleted;
  } catch {
    // Swallow: the page still renders without the deleted list.
    return [];
  }
}
